import React from 'react';
import { HeadProps } from 'gatsby';

import { PageDataModel } from './types';

import { PageContextProvider } from '@brz-utils/contexts/page.context';
import { Head } from '@brz-components/head/head';
import { PageModels } from '@brz-types/page.models';
import { OpenGraphSchema } from '@brz-utils/seo/open.graph';


export const GenericPageHead = (props: HeadProps<PageModels.DataModel<PageDataModel>>) => {
    const { data } = props.data.page.tina;

    return <>
        <PageContextProvider pageSettings={data.node.settings} head>
            <Head />

            <OpenGraphSchema />
        </PageContextProvider>
    </>
};